function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.1 9a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z",
    stroke: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6 4.75h7.25V12l-6.697 6.67a2 2 0 0 1-2.87-.047L5.89 13.94a2 2 0 0 1 .072-2.81L12.6 4.75Z",
    stroke: props.color,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export { SvgTag as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjEgOUMxNi4xIDkuMjc2MTQgMTUuODc2MSA5LjUgMTUuNiA5LjVDMTUuMzIzOCA5LjUgMTUuMSA5LjI3NjE0IDE1LjEgOUMxNS4xIDguNzIzODYgMTUuMzIzOCA4LjUgMTUuNiA4LjVDMTUuODc2MSA4LjUgMTYuMSA4LjcyMzg2IDE2LjEgOVoiIHN0cm9rZT0iIzExMTAxMiIvPgo8cGF0aCBkPSJNMTIuNiA0Ljc1SDE5Ljg1VjEyTDEzLjE1MzUgMTguNjcwOEMxMi4zNTQ1IDE5LjQ2NjggMTEuMDU1NiAxOS40NDUgMTAuMjgzNyAxOC42MjI2TDUuODg5OTQgMTMuOTQxQzUuMTQwNDIgMTMuMTQyNCA1LjE3MjY2IDExLjg4OTUgNS45NjIyOCAxMS4xMzA1TDEyLjYgNC43NVoiIHN0cm9rZT0iIzExMTAxMiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";